<template>
    <div class="col-md-12">
        <div class="col-md-12">
            <div class="h2">Move goods</div>
            <div class="flash-message">
                <FlashMessage :position="'top'"></FlashMessage>
            </div>

                    <div v-if="scanLocationError!==''" class="scan alert alert-danger">
                        <i>{{ scanLocationError }}</i>
                    </div>
                    <div v-if="showBarcodeResult">
                        <div v-if="scanCodeError!==''" class="scan alert alert-danger">
                            <i>{{ scanCodeError }}</i>
                        </div>
                        <div v-else-if="scanCodeSuccess!==''" class="scan alert alert-success">
                            <i>{{ scanCodeSuccess }}</i>
                        </div>
                    </div>

            <div class="row my-3">
                <div class="col-md-4 pl-0">
            <div class="form-group">
                <label class="d-block mb-0 font-weight-bold">Scan barcode</label>
                <stream-barcode-reader @decode="onDecode" @loaded="onLoaded"></stream-barcode-reader>
                <div
                    class="d-flex align-items-center">
                    <div class="bg-white border rounded-lg div-focus border-2">
                        <input type="text"
                               autocomplete="off"
                               class="form-control border-0  shadow-none form-input"
                               placeholder="Scan colli or location"
                               v-model="code"
                               @change="onScan"
                               ref="scanCode">
                    </div>
                </div>
            </div>
                </div>
            </div>
            <div class="form-group">
                <div>
                    <div class="d-flex">
                        <label class="d-block mb-0 font-weight-bold pr-3" for="receiveAll">Select all colli</label>
                        <input type="checkbox"
                               v-model="receiveAll"
                               style="width: 18px;"
                               id="receiveAll"
                               @click="focusOnScan"
                        >
                    </div>
                </div>
            </div>

            <div class="pt-3">
                <div class="table-responsive">
                    <table v-if="collis.length > 0"
                           class="table table-bordered table-striped"
                           aria-label="The list of the collis">
                        <thead>
                        <tr>
                            <th class="border-right text-left">Colli</th>
                            <th class="border-right text-left">Client</th>
                            <th class="border-right text-left"></th>
                        </tr>
                        </thead>
                        <tbody class="table-bordered">
                        <tr v-for="(colli,k) in collis">
                            <td>{{ colli.id }}</td>
                            <td> {{ colli.client.name }}</td>
                            <td class="text-center" style="width: 1%">
                                <div class="btn float-center btn-default btn-sm"
                                     @click="deleteColli(k)">
                                    <div class="material-icons-outlined cursor-pointer text-primary"
                                         title="delete colli from list">delete
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template>
            <div>
                <nested-booking-exist-modal
                    :nestedBooking="nestedBooking"
                    :visible="showNestedModal"
                    actionType="move"
                    @close="showNestedModal = false"
                />

            </div>
        </template>
    </div>

</template>
<script>
import NestedBookingExistModal from "./reusable/NestedBookingExistModal.vue";
import StreamBarcodeReader from "./vue-barcode-reader/StreamBarcodeReader.vue";
export default {
    name: "MoveGoods",
    components: {NestedBookingExistModal, StreamBarcodeReader},
    props: {},
    data() {
        return {
            isSubmit: false,
            collis: [],
            scanCodeError: '',
            scanCodeSuccess: '',
            scanLocationError: '',
            scanLocationSuccess: '',
            showBarcodeResult: true,
            barcode: '',
            barcodes: [],
            locationName: '',
            loadingColli: false,
            code: '',
            receiveAll: false,
            showNestedModal: false,
            nestedBooking: null,
        }
    },
    methods: {
        onScan() {
            if (!this.code) {
                return;
            }

            const isLocation = this.code.match(/\D/);
            if (isLocation) {
                if (!this.barcodes.length) {
                    this.scanCodeError = 'Scan a colli first';
                    this.scanCodeSuccess = '';
                    this.showBarcodeResult = true;
                    return;
                }
                this.locationName = this.code;
                this.onScanLocation();

            } else {
                this.barcode = this.code;
                this.onScanBarcode();
            }
        },
        onScanBarcode(scanAfterLocation = 0) {
            if (this.barcode) {
                let checkColliExists;
                checkColliExists = this.barcodes.includes(parseInt(this.barcode));
                if (checkColliExists) {
                    this.scanCodeError = ' colli already scanned';
                    this.scanCodeSuccess = '';
                    this.showBarcodeResult = true;
                    let audio = new Audio('/assets/beep-warning-6387.mp3');
                    audio.play();
                    this.$refs.scanCode.value = '';
                } else {
                    if (!this.loadingColli) {
                        this.loadingColli = true;
                        axios.get(`/scan-barcode/${this.barcode}/0`, {params: {receiveAll: this.receiveAll}})
                            .then(({data}) => {
                                if (data.message === 'not found') {
                                    this.scanCodeError = ' Colli could not be found';
                                    this.scanCodeSuccess = '';
                                    this.showBarcodeResult = true;
                                    let audio = new Audio('/assets/beep-warning-6387.mp3');
                                    audio.play();
                                } else if(data.data.newBooking) {
                                    this.nestedBooking = data.data.newBooking
                                    this.showNestedModal = true

                                } else {
                                    for (let i = 0; i < data.data.length; i++) {
                                        checkColliExists = this.barcodes.includes(data.data[i].id);
                                        if (!checkColliExists) {
                                            this.collis.push(data.data[i]);
                                            this.barcodes.push(parseInt(data.data[i].id));
                                            this.scanCodeSuccess += `${data.data[i].id}`;
                                            if(i < (data.data.length - 1)) {
                                                this.scanCodeSuccess += ', ';
                                            }
                                        }
                                    }
                                    this.scanCodeError = '';
                                    this.scanCodeSuccess += ` added`;
                                }
                                this.barcode = '';
                                this.code = '';
                            }).catch((error) => {
                                this.scanCodeSuccess = '';
                                this.scanCodeError = (error.response && error.response.data && error.response.data.message) ?
                                    error.response.data.message :
                                    'Error';
                                if (this.scanCodeError === 'Booking is already delivered/rejected. The good requires a new label. Print a new label from desktop') {
                                    let audio = new Audio('/assets/beep-warning-6387.mp3');
                                    audio.play();
                                }
                                this.showBarcodeResult = true;
                                this.barcode = '';
                                this.code = '';
                            })
                            .finally(() => {
                                this.loadingColli = false;
                        });
                    }
                }
            }
        },
        onScanLocation() {
            if (this.locationName !== '') {
                axios.post(`/scan-location/${this.locationName}`, this.barcodes)
                    .then(({data}) => {
                        if (data.colli != null) {
                            this.onScanBarcode(1);
                        } else if (data.location != null) {
                            this.showBarcodeResult = false;
                            this.scanLocationError = '';
                            this.scanLocationSuccess = `colli moved to ${data.location.name}`;
                            this.flashMessage.success({
                                title: '',
                                message: `colli moved to ${data.location.name}`,
                                time: 2000,
                                blockClass: 'flash-message'
                            });
                            this.$nextTick(() => {
                                this.$refs.scanCode.focus();
                            });
                            this.scanCodeError = '';
                            this.scanCodeSuccess = '';
                            this.scanLocationError = '';
                            this.scanLocationSuccess = '';
                            this.showBarcodeResult = true;
                            this.barcode = '';
                            this.code = '';
                            this.barcodes = [];
                            this.collis = [];
                        } else if (data.message != null) {
                            this.scanCodeSuccess = '';
                            this.scanCodeError = 'Colli or location could not be found';
                        }
                    }).catch((error) => {
                        this.scanCodeSuccess = '';
                        this.scanLocationError = (error.response && error.response.data && error.response.data.message) ?
                            error.response.data.message :
                            'Error';
                        if (this.scanLocationError === 'Booking is already delivered/rejected. The good requires a new label. Print a new label from desktop') {
                            let audio = new Audio('/assets/beep-warning-6387.mp3');
                            audio.play();
                        }
                    });
                this.locationName = '';
                this.code = '';
            }
        },
        deleteColli(k) {
            this.collis = this.collis.filter((x, i) => i !== k);
            this.barcodes = this.barcodes.filter((x, i) => i !== k);
        },
        focusOnScan() {
            this.$nextTick(() => {
                this.$refs.scanCode.focus();
            });
        },
        onDecode(value) {
            console.log(value);
            this.code = value;
            this.onScan();
        },
        onLoaded() {
            console.log('StreamBarcodeReader is loaded');
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.scanCode.focus();
        });
    },
}
</script>

<style>
.scan-error {
    color: red;
}

.scan {
    margin-top: 10px;
    margin-left: 10px;
}
</style>
